<script setup>
import CustomMultiselect from '@/components/global-themed/CustomMultiselect.vue';
import {useFeatureFlags} from '@/composables/admin/useFeatureFlags';

const { selectedUserId, searchUsers } = useFeatureFlags();
</script>

<template>
  <div>
    <h2 class="tw-text-lg tw-font-semibold tw-text-font-primary tw-mb-4">
      Search User
    </h2>

    <div class="tw-max-w-lg">
      <CustomMultiselect
        v-model="selectedUserId"
        :options="searchUsers"
        :delay="300"
        :filter-results="false"
        :resolve-on-load="false"
        :min-chars="2"
        :close-on-select="true"
        :can-deselect="true"
        :can-clear="true"
        placeholder="Search by name, email or ID…"
      />
    </div>
  </div>
</template>
